import { defaultPath as agenciesPath } from '../../agencies/routes';
import { defaultPath as clientsPath } from '../../clients/routes';
import { defaultPath as contactsPath } from '../../contacts/routes';
import { defaultPath as ticketsPath } from '../../tickets/routes';
import { defaultPath as settingsPath } from '../../settings/routes';
import { defaultPath as dealersPath } from '../../dealers/routes';
import { defaultPath as dashboardPath } from '../../dashboard/routes';

// NOTE: Accesslevel Profiles
const administrator = 100;
const agent = 20;
const supervisor = 60;

const defaultPermissionRole = {
    tickets: {
        create: true,
        update: true,
        onlyMine: false,
        companies: {
            show: true,
            autoAssigned: false,
            readOnly: false
        },
        contacts: {
            create: true,
            autoAssigned: false,
            readOnly: false
        },
        clients: {
            create: true
        },
        assigned: {
            show: false
        }
    },
    clients: {
        create: true,
        update: true,
        accountSettings: {
            show: true,
            autoCreate: false
        },
        companies: {
            autoAssigned: false,
            onlySame: false
        }
    },
    agencies: {
        companies: {
            onlySame: false,
            readOnly: false
        }
    },
    dashboard: {
        companies: {
            onlySame: false
        }
    }
};

const defaultPermissionEntities = {
    [agenciesPath]: false,
    [clientsPath]: false,
    [contactsPath]: false,
    [ticketsPath]: false,
    [settingsPath]: true,
    [dealersPath]: false,
    [dashboardPath]: false
};

const permissionRole = {
    [administrator]: {
        ...defaultPermissionRole,
        tickets: {
            ...defaultPermissionRole.tickets,
            assigned: {
                ...defaultPermissionRole.tickets.assigned,
                show: true
            }
        }
    },
    [agent]: {
        ...defaultPermissionRole,
        tickets: {
            ...defaultPermissionRole.tickets,
            onlyMine: true,
            companies: {
                ...defaultPermissionRole.tickets.companies,
                show: false,
                autoAssigned: true,
                readOnly: true
            },
            contacts: {
                ...defaultPermissionRole.tickets.contacts,
                autoAssigned: true,
                readOnly: false,
                create: true
            }
        },
        clients: {
            ...defaultPermissionRole.clients,
            accountSettings: {
                ...defaultPermissionRole.clients.accountSettings,
                show: false,
                autoCreate: true
            },
            companies: {
                ...defaultPermissionRole.clients.companies,
                autoAssigned: true,
                onlySame: true
            }
        },
        agencies: {
            ...defaultPermissionRole.agencies,
            companies: {
                ...defaultPermissionRole.agencies.companies,
                onlySame: true,
                readOnly: true
            }
        }
    },
    [supervisor]: {
        ...defaultPermissionRole,
        tickets: {
            ...defaultPermissionRole.tickets,
            companies: {
                ...defaultPermissionRole.tickets.companies,
                show: false,
                autoAssigned: true,
                readOnly: true
            },
            contacts: {
                ...defaultPermissionRole.tickets.contacts,
                autoAssigned: true,
                readOnly: false,
                create: true
            },
            assigned: {
                ...defaultPermissionRole.tickets.assigned,
                show: true
            }
        },
        clients: {
            ...defaultPermissionRole.clients,
            accountSettings: {
                ...defaultPermissionRole.clients.accountSettings,
                show: false,
                autoCreate: true
            },
            companies: {
                ...defaultPermissionRole.clients.companies,
                autoAssigned: true,
                onlySame: true
            }
        },
        agencies: {
            ...defaultPermissionRole.agencies,
            companies: {
                ...defaultPermissionRole.agencies.companies,
                onlySame: true,
                readOnly: true
            }
        },
        dashboard: {
            ...defaultPermissionRole.dashboard,
            companies: {
                ...defaultPermissionRole.dashboard.companies,
                onlySame: true
            }
        }
    }
};

const permissionEntities = {
    [administrator]: {
        ...defaultPermissionEntities,
        [agenciesPath]: true,
        [clientsPath]: true,
        [contactsPath]: true,
        [ticketsPath]: true,
        [settingsPath]: true,
        [dealersPath]: true,
        [dashboardPath]: true
    },
    [agent]: {
        ...defaultPermissionEntities,
        [ticketsPath]: true,
        [clientsPath]: true,
        [contactsPath]: true
    },
    [supervisor]: {
        ...defaultPermissionEntities,
        [ticketsPath]: true,
        [clientsPath]: true,
        [contactsPath]: true,
        [dashboardPath]: true
    }
};

const defaultInitialRoute = {
    [administrator]: ticketsPath,
    [agent]: ticketsPath,
    [supervisor]: ticketsPath
};

export const getAuthProfile = (accessLevel = "") => ({
    authRole: permissionRole[accessLevel] || defaultPermissionRole,
    authEntities: permissionEntities[accessLevel] || defaultPermissionEntities,
    defaultInitialRoute: defaultInitialRoute[accessLevel] || ticketsPath
});

const viewerPermissionRole = {
    ...defaultPermissionRole,
    tickets: {
        ...defaultPermissionRole.tickets,
        create: false,
        update: false,
        companies: {
            ...defaultPermissionRole.tickets.companies,
            show: false,
            autoAssigned: false,
            readOnly: true
        },
        contacts: {
            ...defaultPermissionRole.tickets.contacts,
            create: false,
            autoAssigned: false,
            readOnly: true
        },
        clients: {
            create: false
        },
        assigned: {
            show: true
        }
    },
    clients: {
        ...defaultPermissionRole.clients,
        create: false,
        update: false,
        accountSettings: {
            show: false,
            autoCreate: false
        },
        companies: {
            autoAssigned: false,
            onlySame: false
        }
    }
};

const viewerPermissionEntities = {
    ...defaultPermissionEntities,
    [ticketsPath]: true
};

export const getViewerProfile = () => ({
    authRole: viewerPermissionRole,
    authEntities: viewerPermissionEntities,
    defaultInitialRoute: ticketsPath
});